module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp1_8023.c33554aa.png";